import React from 'react';
import { Circle } from 'rebass';

const Dot = () => <Circle is="span" size={4} p={0} m="auto" />;

export default Dot;



// WEBPACK FOOTER //
// ./src/components/Atoms/Dot/index.js